import ChannelProvider from './ChannelDetailsContext';
import ChannelDetails from './ChannelDetails';
import { Page } from 'components';

let Index = () => {
    return (
        <ChannelProvider>
            <Page title="Channel details" maxWidth='md'>
                <ChannelDetails />
            </Page>
        </ChannelProvider>
    )
}

export default Index;